/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” is a registered trademark of Frictionless Systems, LLC.
 */

package systems.frictionless.analytics.internal

import systems.frictionless.analytics.Analytics
import systems.frictionless.analytics.CrashAnalytics
import systems.frictionless.analytics.model.AnalyticsConfig

actual class DefaultAnalyticsImpl actual constructor(config: AnalyticsConfig, gitCommitCount: Int, gitSha: String) : Analytics {
    private val sentryCrashAnalytics = SentryCrashAnalytics(config, gitCommitCount, gitSha)

    override val crashAnalytics: CrashAnalytics
        get() = sentryCrashAnalytics
}
